import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import * as actionTypes from './actionTypes';
import { snackActions } from '../../../sc-utilities/SnackBar';
import config from '../../../../config/config';


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'customers',
    pluginName: 'CUSTOMER',
    entityName: 'CUSTOMER',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true

});

// Fetch Customer action creators
export const fetchCustomerInit = () => {
    return crudActions.fetchInit();
};
export const fetchCustomerStart = () => {
    return crudActions.fetchStart();
};
export const fetchCustomerSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchCustomerFail = () => {
    return crudActions.fetchFail();
};

export const fetchCustomersCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomerStart());
        try {
            let countRes = await rest.post("customers/count", filterData, { cancelToken: options?.countSource?.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchCustomerSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchCustomerFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch customer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchCustomerFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch customer."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchCustomers = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomerStart());
        try {
            let listRes = await rest.post("customers/list", filterData, { cancelToken: options?.listSource?.token });
            if (listRes && listRes.canceled) {
                return { data: [], count: 0, canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchCustomerSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchCustomerFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchCustomerFail());

            return { data: [] };
        }
    }
};

// Create Customer  action creators
export const createCustomerInit = () => {
    return crudActions.createInit();
};
export const createCustomerStart = () => {
    return crudActions.createStart();
};
export const createCustomerSuccess = createdCustomer => {
    return crudActions.createSuccess(createdCustomer);
};
export const createCustomerFail = error => {
    return crudActions.createFail(error);
};



// Edit Customer  action creators
export const editCustomerInit = () => {
    return crudActions.editInit();
};
export const editCustomerStart = () => {
    return crudActions.editStart();
};
export const editCustomerSuccess = editedCustomer => {
    return crudActions.editSuccess(editedCustomer);
};
export const editCustomerFail = error => {
    return crudActions.editFail(error);
};
export const editCustomer = setting => {
    return async dispatch => {
        await crudActions.edit(dispatch, setting);
    };
};
export const updateCustomer = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editCustomerStart());
        try {
            let res = await rest.post('/customers/save', params, { cancelToken: options?.countSource?.token });
            if (res && res.canceled) {
                return { data: [], count: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                if (params.CustomerID === params.ActiveCustomerID) {
                    dispatch(updateActiveCustomerData(params));
                }
                snackActions.snackBar({
                    message: `Successfully updated customer.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editCustomerFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit customer."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit customer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editCustomerFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const updateActiveCustomerData = params => {
    return {
        type: 'CORE|AUTH|UPDATE_ACTIVE_CUSTOMER_DATA',
        ...params
    }
}

// Load Customer action creators
export const loadCustomerInit = () => {
    return crudActions.loadInit();
};
export const loadCustomerStart = () => {
    return crudActions.loadStart();
};
export const loadCustomerSuccess = loadedCustomer => {
    return crudActions.loadSuccess(loadedCustomer);
};
export const loadCustomerFail = error => {
    return crudActions.loadFail(error);
};

export const loadCustomer = (id, options = {}) => {
    return async dispatch => {
        let res = await crudActions.load(dispatch, id, { cancelToken: options?.cancelToken?.token });
        if (res && res.canceled) {
            return {};
        }
    };
};
export const uploadProgress = (data) => {
    return {
        type: 'CUSTOMER|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};


export const createCustomer = (data, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createCustomerInit());
        try {
            let maxSize = 0

            const config = {
                ...data,

                onUploadProgress: progressEvent => {
                    if (data.File) {
                        maxSize = Math.round((progressEvent.total / 1024));
                        dispatch(uploadProgress({
                            progress: (Math.round((progressEvent.loaded * 100) / data?.File.size) < 100 ? Math.round((progressEvent.loaded * 100) / data?.File?.size) : '100'),
                            loadSize: Math.round((progressEvent.total / 1024)) < Math.round((progressEvent.loaded / 1024)) ? Math.round((progressEvent.loaded / 1024)) : Math.round((progressEvent.total / 1024)), maxSize: Math.round((progressEvent.total / 1024)), snackStart: true
                        }))
                    }
                }

            }

            dispatch(createCustomerStart());
            let res = await rest.post('customers/create', data, config, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return {};
            }
            if (res.status === 200) {
                dispatch(uploadProgress({ progress: 100, loadSize: maxSize, maxSize: maxSize, snackStart: false }))

                dispatch(createCustomerSuccess());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Create customer was successful '}`,
                    options: {
                        variant: 'success',
                        autoHideDuration: 8000
                    }
                });
                return res;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(createCustomerFail());
                return res;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))
            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot create customer'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(createCustomerFail());
            return false;
        }
    }
}



export const fetchYears = (data, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('customers/get_erasure_years', data, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return {};
            }
            if (res.data && res.data.succeeded) {
                const years = [];
                for (var year of res.data.result.data.Years) {
                    years.push({ value: year.Year + '', displayValue: year.Year + '', erasures: year.Erasures });
                }
                years.push({ value: "all", displayValue: "All years", erasures: res.data.result.data.Total });
                return years;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const fetchErasures = (data, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('customers/get_erasures', data, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })

                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
}

export const loadPlans = (customerID) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/account/list-plans', { listAll: true, ...customerID });

            if (res.data && res.data.succeeded) {
                const plans = [];
                for (var plan of res.data.result.data) {
                    plans.push({ value: plan.PlanID, label: plan.Name });
                }
                return plans;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}


export const updatePresets = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/update-presets', params, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                dispatch(updateActiveCustomerData({...params, Presets: JSON.stringify(params.Presets)}))
                return { status: true };
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return { status: false };
            }

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { status: false };
        }
    };
}

export const sendAndroidSetup = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            await rest.post('/mobile-setup/send_email', params)
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    }
}

export const fetchPrinters = (id, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {
                console.log('error')
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const fetchGrades = (id, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    if (grade.GradeID.toLowerCase() === 'info') {
                        continue;
                    }
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}
// Bulk delete customer
export const bulkDeleteCustomersInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteCustomersStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteCustomersSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteCustomersFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteCustomers = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteCustomersStart());
        try {
            let res = await rest.post('/customers/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteCustomersSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted customers.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteCustomersFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete customers."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete customers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteCustomersFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
export const fetchOrders = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('palettes/order/list', { listAll: true, formatForWEBUI: true, ...params }, { cancelToken: options?.cancelToken?.token });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            if (res && res.canceled) {
                return [];
            }
            if (response) {
                return response;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}
export const fetchCollies = (id, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/colli/list', { listAll: true, formatForWEBUI: true, ...id }, { cancelToken: options?.cancelToken?.token });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            if (res && res.canceled) {
                return [];
            }
            if (response) {
                return response;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const fetchOperatingSystems = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/operating_systems/list', { listAll: true, ...params }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const operatingSystems = [];
                for (var os of res.data.result.data) {
                    operatingSystems.push({ value: os.OperatingSystemID, displayValue: `${os.Name}` });
                }
                return operatingSystems;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const recoverPBillingPlansStart = () => {
    return {
        type: actionTypes.ACCOUNT_RECOVER_START,
        loading: true
    };
};
export const recoverPBillingPlansSuccess = () => {
    return {
        type: actionTypes.ACCOUNT_RECOVER_SUCCESS,
        loading: false,
    };
};
export const recoverPBillingPlansFail = () => {
    return {
        type: actionTypes.ACCOUNT_RECOVER_FAIL,
        loading: false
    };
};

export const updateCustomerStore = params => {
    return {
        type: 'CUSTOMER|UPDATE|PRESETS',
        presets: params
    }
}
export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, q: { Visible: [1] }, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}

export const recoverBillingPlan = billingAccount => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(recoverPBillingPlansStart())
            let res = await rest.post('/account/suspend-or-recover', billingAccount);
            if (res.data.status === 200) {
                dispatch(recoverPBillingPlansSuccess())
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.status === 200;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(recoverPBillingPlansFail());

                return false;
            }

        } catch (error) {
            dispatch(recoverPBillingPlansFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
};

export const suspendPBillingPlansStart = () => {
    return {
        type: actionTypes.ACCOUNT_SUSPEND_START,
        loading: true
    };
};
export const suspendPBillingPlansSuccess = () => {
    return {
        type: actionTypes.ACCOUNT_SUSPEND_SUCCESS,
        loading: false,
    };
};
export const suspendPBillingPlansFail = () => {
    return {
        type: actionTypes.ACCOUNT_SUSPEND_FAIL,
        loading: false
    };
};



export const suspendBillingPlan = billingAccount => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(suspendPBillingPlansStart())
            let res = await rest.post('/account/suspend-or-recover', billingAccount);
            if (res.data.status === 200) {
                dispatch(suspendPBillingPlansSuccess())
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status === 200;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(suspendPBillingPlansFail());

                return false;
            }
        } catch (error) {
            dispatch(suspendPBillingPlansFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
};

// custom functions 
export const fetchLogos = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/logos/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const logos = [];
                for (var logo of res.data.result.data) {
                    let relativePath = logo.ImageLocation?.split('/') ?? [];
                    relativePath.shift();
                    logos.push({ value: logo.LogoID, displayValue: logo.Name, imageLocation: `${config.backend_static}/${relativePath.join('/')}` });
                }
                return logos;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}



export const checkFormParams = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/check', data);
            return res.data

        } catch (error) {
            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot check params'}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}